/* eslint-disable no-unused-vars */
// import Slider from 'components/menu';
// export for others scripts to use

import Flickity from "flickity"
import {FlickityResponsive} from "../../../../node_modules/flickity-responsive";
require('flickity-imagesloaded');

window.Flickity = Flickity;

const Slider = () => {
    //Slider Banner
    let flkty;
    let sliderImg = document.querySelectorAll('.slider-img');
    if (sliderImg.length > 0)
        sliderImg.forEach((slider) => {
            flkty = new Flickity(slider, {
                cellAlign: 'left',
                prevNextButtons: true,
                autoPlay: 3000,
                pageDots: true
            });
        });

    //Slider Reals
    let sliderReals = document.querySelectorAll('.slider-reals');
    if (sliderReals.length > 0)
    {
        sliderReals.forEach((slider) => {
            let flkty = new Flickity(slider, {
                cellAlign: 'center',
                pageDots: false,
                imagesLoaded: true,
                contain: true,
                groupCells: true,
                autoPlay: 3000,
                arrowShape: {
                    x0: 10,
                    x1: 60, y1: 50,
                    x2: 60, y2: 45,
                    x3: 15
                }
            });
        });
    }

    // Tabs
    let tabsNav = document.querySelectorAll('.tabs-nav');

    if (tabsNav) {
        tabsNav.forEach((tabs) => {
            let tab = tabs.querySelectorAll('.tab');
            let tabPanel = tabs.closest('.tabs').querySelector('.tabs-panel').querySelectorAll('.panel');

            let flkty1 = new Flickity(tabs, {
                lazyLoad: 6,
                freeScroll: true,
                percentPosition: false,
                prevNextButtons: false,
                pageDots: false,
                resize: true,
                draggable: true,
                cellAlign: 'left',
                contain: true,
            });

            tab.forEach((item, index) => {
                item.addEventListener('click', mouseUpIncontournable, true);
                item.addEventListener('click', () => {
                    Panel(item, index)
                });
            });

            function Panel(item, index) {
                tabPanel.forEach((el) => {
                    el.classList.remove("is-active");
                });
                tabPanel[index].classList.add('is-active');
            }

            function mouseUpIncontournable(e) {
                if (!this.classList.contains('is-selected')) {
                    e.preventDefault();
                    flkty1.select([...this.parentNode.children].indexOf(this));
                }

                if (sliderReals.length > 0) {
                    setTimeout(function () {
                        flkty.positionCells();
                    }, 400)
                }
            }
        })
    }


    // Programme gallery
    let progSlider = document.querySelectorAll('.prog-slider');

    if (progSlider.length) {
        progSlider.forEach((slider) => {
            let flktyProg = new Flickity(slider, {
                wrapAround: true,
                groupCells: true
            });
        });
    }

    let actuSlider = document.querySelectorAll('.slider-actu');

    if (actuSlider) {
        actuSlider.forEach((slider) => {
            flkty = new FlickityResponsive(slider, {
                prevNextButtons: true,
                pageDots: false,
                adaptiveHeight: false,
                groupCells: 1,
                arrowShape: {
                    x0: 10,
                    x1: 60, y1: 50,
                    x2: 60, y2: 45,
                    x3: 15
                },

                responsive: [
                    {
                        breakpoint: 1150,
                        settings: {
                            cellAlign: "center",
                            groupCells: 1,
                            prevNextButtons: true,
                            pageDots: false,

                        }
                    }
                ]
            });
        });
    }

};

export default Slider;